module.exports = __webpack_public_path__ + "img/702-c18e64.png";